import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Documento} from '../models/documento.model';
import {AbstractService} from './abstract.service';

@Injectable({
    providedIn: 'root'
})
export class DocumentoService extends AbstractService<Documento> {

    constructor(
        http: HttpClient) {
        super('v1/documento', http);
    }

    getDocumentos(filter: any) {
        let params = new HttpParams();
        if (filter.tipo) {
            params = params.set('tipo', filter.tipo );
        }
        if (filter.ano) {
            params = params.set('ano', filter.ano );
        }
        if (filter.uf && filter.uf !== 'Todos') {
            params = params.set('sgUf', filter.uf.toString());
        }
        return this.filterByParam(params, 'listarTodos');
    }
}
